import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, ElementRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { environment } from '@coin/shared/core/util-environments';
import { GlobalEventsService } from '@coin/shared/core/util-helpers';
import { BehaviorSubject } from 'rxjs';
import { UserMenuState } from '../header/components/user-menu/state/user-menu.state';
import { MatIcon } from '@angular/material/icon';
import { SidebarMenuItemComponent } from './components/sidebar-menu-item/sidebar-menu-item.component';
import { CollapsedBarComponent } from './components/collapsed-bar/collapsed-bar.component';
import { TranslatePipe } from '@ngx-translate/core';
import { CoinAppsOverviewComponent } from '@coin/shared/auth/feature';

@Component({
  selector: 'cosmos-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, SidebarMenuItemComponent, CoinAppsOverviewComponent, CollapsedBarComponent, TranslatePipe]
})
export class SidebarComponent {
  private readonly eRef = inject(ElementRef);
  private readonly events = inject(GlobalEventsService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);
  private readonly userMenuState = inject(UserMenuState);

  public isSidebarVisible = false;
  public titles: string[] = ['Apps'];
  public selectedMenuItem: string = this.titles[0];
  public environment = environment;
  public userDetails = this.userMenuState.userDetails;
  public sideBarCollapsed$ = new BehaviorSubject<boolean>(!this.isSidebarVisible);

  clickout = (event: MouseEvent): void => {
    if (!this.eRef.nativeElement.contains(event.target)) {
      if (this.isSidebarVisible) {
        this.onSidebarToggle();
        this.cdr.detectChanges();
      }
    }
  };

  constructor() {
    this.events
      .listen('click')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(e => this.clickout(e));
  }

  public onSidebarToggle(title?: string): void {
    if (title) {
      this.selectedMenuItem = title;
    }

    this.isSidebarVisible = !this.isSidebarVisible;
    this.sideBarCollapsed$.next(!this.isSidebarVisible);
  }

  public toggleMenuItem(menuItem: string): void {
    if (this.selectedMenuItem === menuItem) {
      this.selectedMenuItem = '';
    } else {
      this.selectedMenuItem = menuItem;
    }
  }
}
